import React from 'react';
import { roles } from '@nxsys/store/constants';

const NotificationPage = React.lazy(
  () => import('../../../modules/notification'),
);

export const notificationConfig = [
  {
    permittedRole: [roles.admin, roles.employer, roles.employee, roles.agency],
    path: '/notifications',
    element: <NotificationPage />,
  },
];
